<template>
    <div>
        <!-- Top buttons -->
        <div class="w-100">
            <div class="d-flex" style="position: absolute;" :style="['z-index', zIndex]">
                <Button
                    :size="15"
                    color="#fd7e14"
                    colorText="#ffffff"
                    tooltip="Aplicar filtro al contenido"
                    icon="fas fa-filter"
                    round
                    :width="30"
                    class="mt-2 mb-3 mr-2"
                    @click.native="openModal('modal'), ActionSetZindexTablaModal(true)"
                    traslate
                />

                <Button
                    :size="15"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Restablecer contenido filtrado"
                    icon="fas fa-filter"
                    round
                    :width="30"
                    class="mt-2 mb-3 mr-2"
                    traslate
                    @click.native="eliminarFiltros()"

                />
            </div>
        </div>

        <!-- Modal -->
        <ui-modal ref="modal" title="Filtrar Bookings confirmados" size="large" @close="ActionSetZindexTablaModal(false)">

            <!-- Btn Limpiar formulario -->
             

            <!-- <Button
                class="ml-3"
                :size="15"
                color="#FD9137"
                colorText="#ffffff"
                tooltip="Limpiar formulario"
                icon="fas fa-quidditch"
                round
                :width="35"
                traslate
                @click.native="limpiarFormulario()"
            /> -->
            
            <div class="d-flex flex-column p-3">

                <!-- Fila 1 -->
                <div class="d-flex">
                    <!-- ID -->
                    <ui-textbox
                        class="w-100 mr-3"
                        label="ID Booking"
                        v-model="idModel"
                    />

                    <!-- Referencia -->
                    <!-- <ui-textbox
                        class="w-100 mr-3"
                        label="Referencia"
                        v-model="referenciaModel"
                    /> -->

                    <!-- Número de booking -->
                    <ui-textbox
                        class="w-100"
                        label="N° Booking"
                        v-model="nBookingModel"
                    />
                </div>

                <!-- Fila 2 -->
                <div class="d-flex mt-2">

                    <!-- Cliente -->
                    <ui-select
                        class="w-100 mr-3"
                        has-search
                        label="Cliente"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :keys="{ label: 'name', value: 'id' }"
                        :options="customersList"
                        v-model="clienteModel"
                    />

                    <!-- Nave -->
                    <ui-textbox
                        class="w-100 mr-3"
                        label="Nave"
                        v-model="naveModel"
                    />

                    <!-- Naviera -->
                    <ui-select
                        class="w-100"
                        has-search
                        label="Navieras"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :keys="{ label: 'name', value: 'id' }"
                        :options="carriersList"
                        v-model="navieraModel"
                    />

                </div>

                <!-- Fila 3 -->
                <div class="d-flex mt-2">

                    <!-- Puerto de Descarga -->
                    <ui-select
                        class="w-100 mr-3"
                        has-search
                        label="Puerto de Descarga"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :keys="{ label: 'name', value: 'id' }"
                        :options="portsList"
                        v-model="podModel"
                    />

                    <!-- Puerto de Carga -->
                    <ui-select
                        class="w-100 mr-3"
                        has-search
                        label="Puerto de Carga"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :keys="{ label: 'name', value: 'id' }"
                        :options="portsList"
                        v-model="polModel"
                    />

                    <!-- Cantidad -->
                    <ui-textbox
                        class="w-100"
                        label="Cantidad"
                        v-model="cantidadModel"
                    />

                </div>

                <!-- Fila 4 -->
                <div class="d-flex mt-2">

                    <!-- Desde semana -->
                    <ui-select
                        class="w-100 mr-3"
                        has-search
                        label="Desde semana"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :options="semanasList"
                        v-model="desdeSemanaModel"
                    />

                    <!-- Hasta semana -->
                    <ui-select
                        class="w-100 mr-3"
                        has-search
                        label="Hasta semana"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :options="semanasList"
                        v-model="hastaSemanaModel"
                    />

                    <!-- Año -->
                    <ui-select
                        class="w-100"
                        has-search
                        label="Año"
                        placeholder="Seleccionar"
                        searchPlaceholder="Buscar"
                        :options="['2025','2026']"
                        v-model="anioModel"
                    />

                </div>

                <!-- Buttons -->
                <div class="d-flex justify-content-between mt-4">
                    <Button 
                        :size="25"
                        color="#FF0202"
                        colorText="#ffffff"
                        text="Cancelar"
                        :width="110"
                        :height="35"
                        horizontal
                        class="mt-3"
                    />
                    
                    <Button
                        :size="25"
                        color="#FD9137"
                        colorText="#ffffff"
                        text="Limpiar"
                        horizontal
                        :width="130"
                        :height="35"
                        class="mt-3"
                        @click.native="limpiarFormulario()"
                    />

                    <Button 
                        :size="25"
                        color="#00AADE"
                        colorText="#ffffff"
                        text="Filtrar"
                        :width="110"
                        :height="35"
                        horizontal
                        class="mt-3"
                        @click.native="filtrarBookings()"
                    />
                </div>

            </div>

           

        </ui-modal>

    </div>
</template>


<script>

import { mapState, mapActions } from "vuex";

// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiModal from "keen-ui/src/UiModal";
import Button from '../../../common/Button.vue';

export default {
    data() {
        return {
            zIndex : 0,
            idModel : "",
            // referenciaModel : "",
            nBookingModel : "",
            clienteModel : {},
            naveModel : "",
            navieraModel : "",
            podModel : {},
            polModel : {},
            cantidadModel : "",
            desdeSemanaModel : "",
            hastaSemanaModel : "",
            anioModel : "",
            semanasList : ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","51","51","52","53"],
            
        };
    },

        components: {
            UiSelect,
            UiTextbox,
            UiModal,
            Button,
        },

    computed : {
      ...mapState("serviciosLogisticos",["carriersList", "customersList", "portsList"]),
    },

    methods: {

        ...mapActions(["ActionSetZindexTablaModal"]),
        ...mapActions("serviciosLogisticos",["actionSetDataTableListaBookings"]),

        openModal(ref) {
            this.zIndex = 0;
            this.$refs[ref].open();
        },

        closeModal(ref) {
            this.zIndex = 2;
            this.$refs[ref].close();
        },

        limpiarFormulario(){

            this.idModel          = "";
            // this.referenciaModel  = "";
            this.nBookingModel    = "";
            this.clienteModel     = {};
            this.naveModel        = "";
            this.navieraModel     = "";
            this.podModel         = {};
            this.polModel         = {};
            this.cantidadModel    = "";
            this.desdeSemanaModel = "";
            this.hastaSemanaModel = "";
            this.anioModel        = "";

        },

        async filtrarBookings(){

            const dataFilter = {
                "id" : this.idModel ?? "",
                // "referencia" : this.referenciaModel,
                "no_booking" : this.nBookingModel ?? "",
                "cliente" : this.clienteModel.id ?? "",
                "nave" : this.naveModel ?? "",
                "naviera" : this.navieraModel.id ?? "",
                "pod" : this.podModel.id ?? "",
                "pol" : this.polModel.id ?? "",
                "cantidad" : this.cantidadModel ?? "",    //<---- Falta
                "semana_inicio" : this.desdeSemanaModel ?? "",
                "semana_termino" : this.hastaSemanaModel ?? "",
                "anio" : this.anioModel ?? ""

                // "comercial" : "",                <---- Sobra
                // "servicio_integral" : 0,         <---- Sobra
                // "t_servicio_integral" : 0        <---- Sobra
            }
            const payload = {
                filters: dataFilter
            };
            
            

            await this.actionSetDataTableListaBookings( payload);
           
            

        },
        async eliminarFiltros(){

            await this.actionSetDataTableListaBookings( );
        }

    },
};
</script>
